import { Divider, Body, Headline, HStack, Icon, Media, Space, Title2, Title3 } from "@themeable/react";
import Blockquote from "./Blockquote";

export const ContentBlock = ({ block, index }) => {

  if (block.length < 1) {
    return <>
      Loading...
    </>
  } else {

    return <>

      <div key={index}>
        {(() => {
          switch (block.type) {
            case 'paragraph': return (
              <Body tag='p'>
                {block.paragraph.rich_text.map((chunk, index) => (
                  <>
                    {chunk.href ? (
                      <a
                        style={{ color: 'rgba(var(--color-primary))' }}
                        href={chunk.href}
                        target={chunk.href.includes('localhost') || chunk.href.includes('redeemingspecialneeds.com') ? undefined : '_blank'}
                        rel={chunk.href.includes('localhost') || chunk.href.includes('redeemingspecialneeds.com') ? undefined : 'noopener noreferrer'}
                      >
                        {chunk.plain_text}
                      </a>
                    ) : chunk.annotations?.bold ? (
                      <span>
                        <strong>
                          {chunk.plain_text}
                        </strong>
                      </span>
                    ) : chunk.annotations?.italic ? (
                      <span>
                        <em>
                          {chunk.plain_text}
                        </em>
                      </span>
                    ) : (
                      <>
                        <span>
                          {chunk.plain_text}
                        </span>
                      </>
                    )}
                  </>
                ))}
              </Body>
            )
              break;
            case 'heading_1':
              const heading1 = block.heading_1.rich_text[0].plain_text
                .trim();
              const heading1Anchor = heading1.trim().toLowerCase()
              return (
                <>
                  <Space.NewSection />
                  {heading1.includes('##') ? (
                    <span id={heading1Anchor
                      .toLowerCase()
                      .substring(4)
                      .trim()
                      .replaceAll(/\s+/g, '-')
                      .replaceAll(/[^a-z0-9-]/g, '')
                    }>
                      <HStack align='middle'>
                        <Icon
                          name={heading1.substring(2, 4).trim()}
                          color='accent'
                          size='80px'
                        />
                        <Title2 tag='h2' color="accent">
                          {heading1.substring(4).trim()}
                        </Title2>
                      </HStack>
                    </span>
                  ) : (
                    <span id={
                      heading1Anchor
                        .toLowerCase()
                        .trim()
                        .replaceAll(/\s+/g, '-')
                        .replaceAll(/[^a-z0-9-]/g, '')
                    }>
                      <Title2 tag='h2' color="primary">
                        {heading1.trim()}
                      </Title2>
                    </span>
                  )}
                </>
              )
              break;
            case 'heading_2':
              const heading2 = block.heading_2.rich_text[0].plain_text
                .trim();
              const heading2Anchor = heading2.trim().toLowerCase()

              return (
                <>
                  <Space.NewSection />
                  {heading2.includes('##') ? (
                    <span id={heading2Anchor
                      .substring(4)
                      .toLowerCase()
                      .trim()
                      .replaceAll(/\s+/g, '-')
                      .replaceAll(/[^a-z0-9-]/g, '')

                    }>
                      <HStack align='middle'>
                        <Icon
                          name={heading2.substring(2, 4).trim()}
                          color='accent'
                          size='64px'
                        />
                        <Title3 tag='h2' color="accent">{heading2.substring(4).trim()}</Title3>
                      </HStack>
                    </span>
                  ) : (
                    <span id={heading2Anchor
                      .toLowerCase()
                      .trim()
                      .replaceAll(/\s+/g, '-')
                      .replaceAll(/[^a-z0-9-]/g, '')
                    }>
                      <Title3 tag='h3' color="accent">
                        {heading2.trim()}
                      </Title3>
                    </span>
                  )}
                </>
              )
              break;
            case 'heading_3': return (
              <span id={block.heading_3.rich_text[0].plain_text.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '')}>
                <Headline tag='h4'>
                  {block.heading_3.rich_text[0].plain_text}
                </Headline>
              </span>
            )
              break;
            case 'quote': return (
              <Blockquote>
                {block.quote.rich_text[0].plain_text}
              </Blockquote>
            )
              break;
            case 'divider': return (
              <Divider />
            )
              break;
            case 'callout': return (
              <Container variant='fill'>
                <Section>
                  <HStack>
                    <Body>
                      {block.callout.icon.emoji}
                    </Body>
                    <Body tag='h5'>
                      {block.callout.rich_text[0].plain_text}
                    </Body>
                  </HStack>
                </Section>
              </Container>
            )
              break;
            case 'image': return (
              <>
                <Media
                  caption={block.image.caption[0].plain_text}
                  imageSrc={block.image.file.url}
                  showCaption
                />
              </>
            )
              break;
            case 'numbered_list_item': return (
              <>
                <Body>
                  <span>- {block.numbered_list_item.rich_text[0].plain_text}
                  </span>
                </Body>
              </>
            )
              break;
            case 'bulleted_list_item': return (
              <>
                <Body>
                  <span>- {block.bulleted_list_item.rich_text[0].plain_text}
                  </span>
                </Body>
              </>
            )
              break;
            default: return ''
              break;
          }
        })()}
      </div>

    </>
  }
}
